<template>
  <div class="headerCate">
    <h1>Lista de Usuarios</h1>

    <v-data-table :headers="headers" :items="userAdmin" :header-props="{ class: 'red-header' }" :search="searchTerm"
      :custom-filter="filterOnlyCapsText">
      <!-- Sección superior de la tabla -->
      <template v-slot:top>
        <div style="margin-bottom: 50px">
          <div class="row justify-space-between mx-auto">
            <v-text-field label="Buscador" placeholder="Ingrese por favor una palabra" append-icon="mdi-magnify" dense
              outlined class="col-md-5" @input="search"></v-text-field>
            <template>
              <div class="button-container">
               <!-- <div>
                  <uploadFile style=" margin: -12px;" />
                </div>-->
                <div>
                  <addUserAdmin />
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>

      <!-- Slot para nombreCompleto -->
      <template v-slot:[`item.fullName`]="{ item }">
        <span class="custom-font">{{ item.firstName }} {{ item.middleName }} {{ item.lastName }} {{ item.secondLastName
          }}</span>
      </template>

      <!-- Slot para identificacion -->
      <template v-slot:[`item.identificationNumber`]="{ item }">
        <span class="custom-font">{{ item.identificationNumber }}</span>
      </template>

      <!-- Slot para correo -->
      <template v-slot:[`item.emailAddress`]="{ item }">
        <span class="custom-font">{{ item.emailAddress }}</span>
      </template>

      <!-- Slot para rol -->
      <template v-slot:[`item.role.nameRole`]="{ item }">
        <span class="custom-font">{{ item.role.nameRole }}</span>
      </template>


      <template v-slot:[`item.action`]="{ item }">
        <!-- Botón de acción para abrir el diálogo de detalles  -->
        <v-icon color="primary" size="x-large"></v-icon>

        <div class="actions">

          <detailsUserAdmin :status="item.activeDialogClient" :disableUser="true || item.role.roleId === 1"
            :usersAdminProps="item.userId" style="margin-left:1vh"><v-btn icon x-large dark text>
              <v-icon class="mt-2" color="primary">mdi-border-color</v-icon>
            </v-btn>
          </detailsUserAdmin>
          <v-btn class="btnDetails" icon x-large dark text style="background-color: transparent; margin-left:1vh"
            @click="deleteUserAdmin(item.userId)">
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>

        </div>
      </template>

    </v-data-table>

  </div>
</template>

<script>
import addUserAdmin from "@/views/users_admin/pages/add_users_admin/add_users_admin_page.vue";
import detailsUserAdmin from "@/views/users_admin/pages/detail_users_admin/detail_users_admin_pague.vue";
//import uploadFile from "@/views/users_admin/pages/upload_file/upload_file_page.vue"
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import EventBus from "@/utils/event_bus.js";

import {
  USERSADMIN_M,
  ACTION_LIST_USERSADMIN,
  GET_USERSADMIN,
  ACTION_DELETE_USERSADMIN,
} from "@/views/users_admin/store/types/types.js";

export default {
  name: "listUserAdminComponent",
  components: {
    addUserAdmin,
    detailsUserAdmin,
   // uploadFile
  },

  data() {
    return {
      searchTerm: "",
      modos: [],
      id: null
    };
  },
  async mounted() {
    await this.getActionUserAdmin(this.userId);

    EventBus.$on('reload-UserAdmin', async () => {
      await this.reloadUserAdmin();
    });

    EventBus.$on('reload-update-usersAdmin', async () => {
      await this.reloadUserAdmin();
    });

    EventBus.$on('reload-delete-userAdmin', async () => {
      await this.reloadUserAdmin();
    });

  },

  methods: {

    ...mapActions({
      getActionUserAdmin: `${USERSADMIN_M}${ACTION_LIST_USERSADMIN}`,
      deleteActionUserAdmin: `${USERSADMIN_M}${ACTION_DELETE_USERSADMIN}`,
    }),

    async reloadUserAdmin() {
      await this.getActionUserAdmin(this.userId);
    },
    openUploadModal() {

      this.showUploadFileComponent = true;
      this.showUploadModal = false;
    },

    filterOnlyCapsText(value, query, item) {

      const fullName = [item.firstName, item.middleName, item.lastName, item.secondLastName]
        .filter(name => name != null && name.trim() !== '')
        .join(' ');

      const email = item.emailAddress || "";
      const identificationNumber = item.identificationNumber || "";

      const isFullNameMatched = fullName.toUpperCase().includes(query.toUpperCase());

      const isComplet =
        item.firstName.toUpperCase().includes(query.toUpperCase()) ||
        item.lastName.toUpperCase().includes(query.toUpperCase()) ||
        email.toUpperCase().includes(query.toUpperCase()) ||
        identificationNumber.toUpperCase().includes(query.toUpperCase())

      return isFullNameMatched || isComplet;
    },


    search() {
      // Actualiza el término de búsqueda
      this.searchTerm = event.target.value;
    },

    async deleteUserAdmin(userId) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#6E17A5'
      });

      if (result.isConfirmed) {

        this.deleteActionUserAdmin(userId);
        this.reloadUserAdmin();

      } else {
        Swal.fire({
          position: 'top-end',
          icon: 'info',
          title: 'La acción ha sido cancelada.',
          showConfirmButton: false,
          timer: 2500
        });
      }
    },

  },

  computed: {


    ...mapGetters({
      userAdmin: `${USERSADMIN_M}${GET_USERSADMIN}`,
    }),

    headers() {
      return [
        {
          text: "Nombre",
          value: "fullName",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Identificación",
          value: "identificationNumber",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Correo",
          value: "emailAddress",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Rol",
          value: "role.nameRole",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          //text: "Acciones",
          value: "action",  // Cambiado de 'action' a 'actions'
          sortable: false,
          align: "center",
          //class: "primary--text custom-header mdi-pencil text-subtitle-1",
        },
      ];
    },
  },

};
</script>

<style lang="css" scoped>
.headerCate h1 {
  margin-bottom: 30px;
}

.headerCate {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

.actions v-icon {
  font-size: 24px;
}

.custom-font {
  font-size: 20px;
}

/* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

/* Estilos para el botón de eliminar */
.btnDetails .v-icon {
  color: #6E17A5;
  margin-bottom: 19px;
}

.button-container {
  display: flex;
  justify-content: flex-start;
  /* Change here */
  align-items: flex-start;
  /* Also change here for consistency */
  gap: 25px;
}

/**estilo de los iconos */
.actions {
  display: flex;

}

/* .marginIcon{
    margin-top: 12;
  } */

img {
  width: 3rem;
  height: 3rem;
}

@media screen and (max-width: 414px) {

  h1 {
    font-size: 3vh;
    margin-left: 2vh
  }

  .custom-font {
    font-size: 13px;
  }

  img {
    margin-top: 18px;
    margin-bottom: auto;
    width: 3rem;
    height: 3rem;
  }
}

@media screen and (min-width: 414px) {

  h1 {
    font-size: 4vh;
    margin-left: 2vh
  }

}

@media screen and (max-width: 280px) {

  h1 {
    font-size: 3vh;
    margin-left: 2vh
  }

  h2 {
    font-size: 2vh;
  }

  .custom-font {
    font-size: 13px
  }

  img {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 3rem;
    height: 3rem;
  }
}

@media screen and (max-width: 600px) {

  .button-container {
    flex-direction: column;
    align-items: center;
  }


}
</style>
